import { IPictureFileMetadataResponse } from '@kcftech/prometheustypescriptapiclient';
import { BreadcrumbSeparator, BreadcrumbText } from 'pages/Settings/FileLibrary/styled';

export type FileBreadcrumbProps = Readonly<{
    onBreadcrumbClick: (folderData: IPictureFileMetadataResponse) => void;
    foldersHierarchy: IPictureFileMetadataResponse[];
    rootFolder: IPictureFileMetadataResponse;
}>;

export function FileBreadcrumb({
    onBreadcrumbClick,
    foldersHierarchy,
    rootFolder,
}: FileBreadcrumbProps) {
    return (
        <div className="p-2">
            <BreadcrumbText onClick={() => onBreadcrumbClick(rootFolder)}>
                File Library
            </BreadcrumbText>
            {foldersHierarchy.length !== 0 && (
                <BreadcrumbSeparator className="mx-5">/</BreadcrumbSeparator>
            )}
            {foldersHierarchy.map((folder, index, array) => {
                const isLastFolder = index === array.length - 1;
                return (
                    <>
                        <BreadcrumbText onClick={() => onBreadcrumbClick(folder)}>
                            {folder.DisplayName}
                        </BreadcrumbText>
                        {!isLastFolder && (
                            <BreadcrumbSeparator className="mx-5">/</BreadcrumbSeparator>
                        )}
                    </>
                );
            })}
        </div>
    );
}
